<div class="d-flex">
    <div class="divider"></div>

    @if (isAutoMeasureEnabled) {
        @if (takeOffAddOnService.hasAddOn()) {
            <button
                [disabled]="!isPlanScaled()"
                [tooltip]="!isPlanScaled() ? 'Please scale the plan' : 'Auto measure'"
                id="auto-measure-takeoff"
                class="btn-bx-pro btn-large"
                [cdkMenuTriggerFor]="autoMeasureMenu">
                <img class="detailed-logo" src="../../../../../assets/images/add-ons/blu-logo.svg" alt="blu-logo" />
                Takeoff Assistant
            </button>
        } @else if (takeOffAddOnService.canTakeOffAddonBeSubscribed()) {
            <button
                [disabled]="!isPlanScaled()"
                [tooltip]="!isPlanScaled() ? 'Please scale the plan' : 'Auto measure'"
                id="need-add-on"
                class="btn-bx-pro btn-large"
                (click)="needAddOnAbility()">
                <img class="detailed-logo" src="../../../../../assets/images/add-ons/blu-logo.svg" alt="blu-logo" />
                Takeoff Assistant
            </button>
        }
    }
</div>
<ng-template #autoMeasureMenu>
    <div class="dropdown-menu-container mt-1" cdkMenu>
        <div class="dropdown-menu-header mb-1">Auto measure</div>
        <a class="btn-flat" id="auto-measure-floor-areas" (click)="autoMeasure('FLOOR_AREAS')">
            <i class="fa-kit fa-bx-measure-magic mr-2"></i>Floor areas
        </a>
        <a class="btn-flat" id="auto-measure-perimeter" (click)="autoMeasure('PERIMETER')">
            <i class="fa-light fa-draw-square mr-2"></i>
            Perimeter
        </a>
    </div>
</ng-template>
